import React from 'react'
import { useTranslation } from 'react-i18next'
import { Stack, Typography } from '@mui/material'
import plug from '@assets/icons/plug-logo.png'
import KidGif from '@assets/kid-dance.gif'

export const WalletSetupSuccess = () => {
  const { t } = useTranslation()

  return (
    <Stack
      direction="column"
      spacing={2}
      alignContent="center"
      justifyContent="center"
      flex={1}
      height="100%"
      justifyItems="center"
      px={4}
    >
      <img src={plug} width="120px" style={{ alignSelf: 'center' }} />
      <Stack spacing={1}>
        <Typography fontWeight="bold" textAlign="center" variant="h5">
          {t('walletSuccess.title')}
        </Typography>
        <Typography textAlign="center" variant="body2" color="text.secondary">
          {t('walletSuccess.description')}
        </Typography>
      </Stack>
      <img src={KidGif} style={{ borderRadius: 10 }} />
    </Stack>
  )
}
